import Vue from 'vue'
import VueI18n from 'vue-i18n'
import _mergeWith from 'lodash.mergewith'
import { EventBusVm } from '../plugins/eventBus'
import en from './en'
import fr from './fr'
// import es from './es'

const messages = { en, fr }
export const supportedLocales = Object.keys(messages)
const [systemLocale] = Intl.DateTimeFormat().resolvedOptions().locale.split('-')
const isFrUrl = /forum-ameriques\.org/.test(window.location.host) || /^\/fr\//.test(window.location.pathname)
const urlLocale = isFrUrl ? 'fr' : null
const fallbackLocale = supportedLocales.includes(systemLocale) ? systemLocale : 'en'
const locale = urlLocale || localStorage.getItem('feia-lang') || fallbackLocale

Vue.use(VueI18n)
const i18n = new VueI18n({ locale, messages })

const reduceContent = apiContent =>
  Object.values(apiContent).reduce((content, { id, slug, data }) => ({ ...content, [slug]: { ...data, id } }), {})

const addMessages = (lang, apiContent, conferences) =>
  i18n.setLocaleMessage(
    lang,
    _mergeWith(
      messages[lang],
      { ...reduceContent(apiContent), conferences: reduceContent(conferences) },
      (objValue, srcValue) => {
        if (!Array.isArray(objValue)) return undefined
        return srcValue || objValue
      }
    )
  )

Promise.all([
  fetch(`https://api.forum-americas.org/?rest_route=/wcd/v1/pages`).then(res => res.json()),
  fetch(`https://api.forum-americas.org/?rest_route=/wcd/v1/pages&lang=fr`).then(res => res.json()),
  fetch(`https://api.forum-americas.org/?rest_route=/wcd/v1/data/conference`).then(res => res.json()),
  fetch(`https://api.forum-americas.org/?rest_route=/wcd/v1/data/conference&lang=fr`).then(res => res.json())
]).then(([enPages, frPages, enConferences, frConferences]) => {
  addMessages('en', enPages, enConferences)
  addMessages('fr', frPages, frConferences)
  EventBusVm.contentLoaded = true
  return new VueI18n({ locale, messages })
})

export default i18n
